(function() {
  'use strict';

  function initCategorySlider(container = document) {
    const sections = container.querySelectorAll('.category-slider');
    if (!sections.length) return;

    sections.forEach(function(section) {
      const swiperElement = section.querySelector('.swiper');
      if (!swiperElement) return;

      window.loadThemeSwiper().then(() => {
        initSwiper(section, swiperElement);
      }).catch((error) => {
        console.warn('Swiper failed to load for CategorySlider:', error);
      });
    });
  }

  function initSwiper(section, swiperElement) {
    const navPrev = section.querySelector('.category-slider__nav-btn--prev');
    const navNext = section.querySelector('.category-slider__nav-btn--next');

    const slidesDesktop = parseInt(section.dataset.slidesDesktop) || 7;
    const slidesTablet = parseInt(section.dataset.slidesTablet) || 6;
    const slidesMobile = parseInt(section.dataset.slidesMobile) || 3;
    const spaceBetween = parseInt(section.dataset.spaceBetween) || 30;
    const spaceBetweenMobile = parseInt(section.dataset.spaceBetweenMobile) || 15;
    const loopEnabled = section.dataset.loop !== 'false';
    const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;
    const loop = loopEnabled && slideCount > slidesDesktop;
    const speed = parseInt(section.dataset.speed) || 300;
    const autoplay = section.dataset.autoplay === 'true' ? {
      delay: parseInt(section.dataset.autoplayDelay) || 4000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true
    } : false;

    new Swiper(swiperElement, {
      slidesPerView: slidesDesktop,
      spaceBetween: spaceBetween,
      loop: loop,
      speed: speed,
      navigation: navPrev && navNext ? {
        nextEl: navNext,
        prevEl: navPrev
      } : false,
      breakpoints: {
        320: {
          slidesPerView: slidesMobile,
          spaceBetween: spaceBetweenMobile
        },
        480: {
          slidesPerView: slidesMobile + 1,
          spaceBetween: spaceBetweenMobile + 5
        },
        640: {
          slidesPerView: slidesTablet,
          spaceBetween: spaceBetween - 5
        },
        768: {
          slidesPerView: slidesTablet + 1,
          spaceBetween: spaceBetween
        },
        1024: {
          slidesPerView: slidesDesktop,
          spaceBetween: spaceBetween
        }
      },
      autoplay: autoplay
    });
  }

  if (!customElements.get('category-slider-section')) {
    class CategorySliderSection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        setTimeout(() => initCategorySlider(this), 0);
      }
    }
    customElements.define('category-slider-section', CategorySliderSection);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initCategorySlider();
  });
})();
